/**
 * @file Feedback.tsx
 * @description 反馈组件，用于收集用户反馈信息
 */

import { FC, useContext, useEffect, useRef } from 'react';
import cn from 'classnames';
import { StoreContext, namespace } from '@/context';
import { rateComponent } from '@/utils/feedback';
import { IUserLoginInfo } from '@/api/user';
import { isMobile } from '@/utils';
import Styles from './feedback.module.scss';

export interface FeedbackProps {
  className?: string;
}

export const Feedback: FC<FeedbackProps> = (props) => {
  const { className } = props;
  const ref = useRef<HTMLDivElement>(null)
  const { state } = useContext(StoreContext);

  const account = state[namespace.app]?.account;

  useEffect(() => {
    rateComponent(account as IUserLoginInfo, isMobile, ref?.current)
  }, [account]);

  return <div ref={ref} className={cn(Styles['pc-feedback'], className)} />
}
